export default "__VITE_ASSET__h0u1VpbE__"